module.exports = __webpack_public_path__ + "img/title.f16f18b5.png";